// const registerDefault = {
//   agree_to_terms: 0,
//   birthday_day: '',
//   birthday_month: '',
//   birthday_year: '',
//   body_fat: '',
//   calorie_restricted: 0,
//   currPage: 0,
//   email_address: '',
//   confirm_email_address: '',
//   experience_level: '',
//   fat_content: 3,
//   full_name: '',
//   gender: '',
//   goal: '',
//   goal_level: 'EASY',
//   goal_weight_delta: 0,
//   goal_min_weekly_calorie_increase: 45,
//   previous_diet_calories: 2000,
//   height: '',
//   height_feet: '',
//   height_inch: '',
//   // highLow: '',
//   maintenance_calories: '',
//   use_metric_units: '0',
//   weight: '',
//   wellnessCode: '',
//   password: '',
//   diet_restrictions: new Set(),
//   selected_plan: 'MONTHLY BASIC',
//   target_weight: '',
// }

const registerDefault = {
  agree_to_terms: 0,
  birthday_day: '',
  birthday_month: '',
  birthday_year: '',
  body_fat: '',
  calorie_restricted: 0,
  currPage: 0,
  bfCalculatedType: '',
  challenge: false,
  email_address: '',
  confirm_email_address: '',
  activity_level_life: '0',
  activity_level_exercise: '0',
  experience_level: 'BEGINNER',
  fat_content: 3,
  fat_permyriad: 3000,
  full_name: '',
  gender: '',
  goal: 'FAT LOSS',
  goal_level: 'EASY',
  goal_weight_delta: 0,
  goal_min_weekly_calorie_increase: 45,
  previous_diet_calories: 2000,
  height: '',
  height_feet: '',
  height_inch: '',
  // highLow: '',
  maintenance_calories: '',
  use_metric_units: '0',
  weight: '',
  wellnessCode: '',
  password: '',
  diet_restrictions: new Set(),
  selected_plan: 'MONTHLY BASIC',
  target_weight: '',
}

export default (state=registerDefault, action) => {
  switch(action.type) {
    case 'CREATE_USER_PENDING':
      break;
    case 'CREATE_USER_FULFILLED':
      state = {...state,
        response: 'User created',
        responseColor: 'green'
      }
      break;
    case 'CREATE_USER_REJECTED':
      state = {...state,
        response: action.payload.response.data.error,
        responseColor: 'red'
      }
      break;
    case 'REGISTRATION_SET_USERID':
      state = {
        ...state,
        userId: action.payload.userId
      }
      break;
    case 'CHECK_WELLNESS_CODE_FULFILLED':
      state = {...state,
        validWellnessCode: action.payload
      }
      break;
    case 'FETCH_PARTNERS_PENDING':
      break;
    case 'FETCH_PARTNERS_FULFILLED': // Does not need to exist in store
      break;
    case 'FETCH_PARTNERS_REJECTED':
      break;
    case 'UPDATE_REGISTRATION_FIELD':
      state = {...state,
        ...action.payload
      }
      break;
    case 'VALIDATION_ERRORS':
      state = {...state,
        errors: action.payload.errors,
      }
      break;
    case 'RESET_ON_FAIL':
      state = {...state, ...action.payload }
      break;
    case 'RESET_ALL_FIELDS':
      state = registerDefault
      break;
    default: break; // Do nothing
  }
  return state;
};
